@switch (pickerButtonType()) {
  @case ('icon') {
    <u-icon
      [class.readonly]="['readonly', 'loading'].includes(stateElement())"
      [class.popup-open]="statusPopup()"
      [class.icon-type]="displayModel()?.type.includes('font')"
      [class.placeholder]="placeholderState()"
      class="select-button border"
      (click)="!['readonly', 'loading'].includes(stateElement()) ? openPickerPopup($event) : null"
      [model]="displayModel()"
      [inSvg]="iconInSvg ? displayModel()?.value?.lightUrl : null"
      [styles]="{ fontSize: placeholderFontSize, color: placeholderColor, width: placeholderFontSize, height: placeholderFontSize }"
    ></u-icon>

    @if (stateElement() === 'loading') {
      <u-icon class="loading-icon" [model]="{ type: 'font', value: 'u-spin icon-spinner' }" [styles]="{ fontSize: '24px' }"></u-icon>
    }
  }
  @case ('emoji') {
    <div
      class="select-button border"
      [class.readonly]="stateElement() === 'readonly'"
      [class.popup-open]="statusPopup()"
      (click)="stateElement() !== 'readonly' ? openPickerPopup($event) : null"
    >
      <u-emoji [spriteEmojiSize]="spriteEmojiSize" [emoji]="sheet" [unicode]="emojiUnicode" [nativePrefix]="nativePrefix"></u-emoji>
    </div>
  }
}
